const tableDataStateConstantsAr = {
  noData: 'لا يوجد بيانات',
  noMatchingData: 'لم يتم العثور على نتائج مطابقة',
};
export default tableDataStateConstantsAr;
